import { ChangeEvent, RefObject, useRef } from 'react';
import { Action, Bottom, Icon, LeftSide, NotionAction } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { REACT_APP_BLOCKSUITE_URL } from '../../../global/environment';
import ModalHeader from '../modalHeader';
import { ICON_SIZE } from '../../../global/constants';

interface Props {
  onClose: () => void;
  editorIframe: RefObject<HTMLIFrameElement>;
}
export default function ImportModal(props: Props) {
  const { onClose, editorIframe } = props;
  //Refs
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileInput = (type: 'html' | 'markdown') => {
    if (fileInputRef.current) {
      if (type === 'html') fileInputRef.current.accept = '.html';
      if (type === 'markdown') fileInputRef.current.accept = '.md';
      fileInputRef.current.click();
    }
  };

  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (!file) return;
    const accept = fileInputRef.current?.accept as '.html' | '.md';
    const fileType = accept === '.html' ? 'html' : 'markdown';
    const text = (await file.text()).replace('<!doctype html>', '');
    editorIframe.current?.contentWindow?.postMessage(
      { type: 'import', importType: fileType, data: text },
      `${REACT_APP_BLOCKSUITE_URL}`
    );
    onClose();
  };

  return (
    <>
      <ModalHeader
        title='Import'
        description='Teamcamp will gradually support more file formats for import.'
        onClose={onClose}
      />
      <Bottom>
        <input
          type='file'
          ref={fileInputRef}
          hidden
          multiple={false}
          onChange={handleFileUpload}
          aria-label='Upload file'
        />
        <Action role='button' onClick={() => handleFileInput('markdown')}>
          <Icon>
            <SVGIcon
              name='markdown-icon'
              width={ICON_SIZE.LG}
              height={ICON_SIZE.LG}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
          </Icon>
          <p>Markdown</p>
        </Action>
        <Action role='button' onClick={() => handleFileInput('html')}>
          <Icon>
            <SVGIcon
              name='html-code-icon'
              width={ICON_SIZE.LG}
              height={ICON_SIZE.LG}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              className='html'
            />
          </Icon>
          <p>HTML</p>
        </Action>
        <NotionAction>
          <LeftSide>
            <Icon>
              <SVGIcon
                name='notion-icon'
                width={ICON_SIZE.LG}
                height={ICON_SIZE.LG}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                fill='var(--text-primary)'
              />
            </Icon>
            <p>Notion</p>
          </LeftSide>
          <Icon>
            <SVGIcon
              name='notion-info-icon'
              width={ICON_SIZE.LG}
              height={ICON_SIZE.LG}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
          </Icon>
        </NotionAction>
      </Bottom>
    </>
  );
}
